import { Pipe, PipeTransform } from '@angular/core';

/**
 * pipe to filter an array
 */


export class FilterColumn implements PipeTransform {
  transform(columns: any[], param: string): any[] {
    return columns.filter(col => col[param]);
  }
static decorators: DecoratorInvocation[] = [
{ type: Pipe, args: [{ name: 'filterColumn', pure: true }, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
